import { CryptoRewardsOrdersListSuccessResponse } from 'components/features/rewards/rewardsPane/types/apiResponses'
import { createAction } from 'helpers/actionHelpers/createAction'
import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'

export class GetCryptoRewardsOrdersListRequestAction extends (
  createRequestAction<'API_REQUEST_GET_CRYPTO_REWARDS_ORDERS_LIST', void, CryptoRewardsOrdersListSuccessResponse['items']>('API_REQUEST_GET_CRYPTO_REWARDS_ORDERS_LIST')
) {}

export class CryptoRewardsOrdersListResetErrorsAction extends (
  createAction<'CRYPTO_REWARDS_ORDERS_LIST_RESET_ERRORS_ACTION', void>('CRYPTO_REWARDS_ORDERS_LIST_RESET_ERRORS_ACTION')
) {}

export type CryptoRewardsOrdersActions =
  | CryptoRewardsOrdersListResetErrorsAction
  | typeof GetCryptoRewardsOrdersListRequestAction.Type
